import React, {useRef} from 'react';
import retraite from '../../../../assets/images/svg/111-rocking-chair.png';
import activite from '../../../../assets/images/svg/035-id-card.svg';
import pole from '../../../../assets/images/svg/066-job-interview.svg';
import autre from '../../../../assets/images/svg/034-clipboard.svg';
import maison from '../../../../assets/images/svg/069-home.svg';
import {ProfessionOptions} from '../../../../constants/utils/connectionTypes';

export const ProfessionalSituationForm = ({ personalData, setPersonalData, formReference }) => {
	const professionForm = useRef(null);

	return (
		<section className="block mt-2 pt-2">
			<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-1">Situation Professionnelle *</h4>
			<form className={"py-sm"} noValidate ref={formReference}>
				<div className={"d-block mb-3"}>
					{/* <h5 className="h5 text-uppercase font-weight-bolder mb-2">JE SUIS</h5> */}
					<div className="form-row">
						<div className="form-group col col-lg-4 col-xl-2">
							<div
								className={"card card-body text-center picker-card" + (personalData.professionalSituation.includes(ProfessionOptions.active) ? " active" : "")}
								onClick={() => {
									if (!personalData.professionalSituation.includes(ProfessionOptions.active) && !personalData.professionalSituation.includes(ProfessionOptions.unemployed)) {
										setPersonalData({ ...personalData, professionalSituation: [...personalData.professionalSituation.slice(), ProfessionOptions.active] });
									} else {
										setPersonalData({ ...personalData, professionalSituation: personalData.professionalSituation.filter((p) => p !== ProfessionOptions.active) });
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={activite} alt="activite" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">EN ACTIVITÉ(E)</h2>
							</div>
						</div>
						<div className="form-group col col-lg-4 col-xl-2">
							<div
								className={"card card-body text-center picker-card" + (personalData.professionalSituation.includes(ProfessionOptions.retired) ? " active" : "")}
								onClick={() => {
									if (!personalData.professionalSituation.includes(ProfessionOptions.retired) && !personalData.professionalSituation.includes(ProfessionOptions.unemployed)) {
										setPersonalData({ ...personalData, professionalSituation: [...personalData.professionalSituation.slice(), ProfessionOptions.retired] });
									} else {
										setPersonalData({ ...personalData, professionalSituation: personalData.professionalSituation.filter((p) => p !== ProfessionOptions.retired) });
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={retraite} alt="retraite" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">RETRAITÉ(E)</h2>
							</div>
						</div>

						<div className="form-group col col-lg-4 col-xl-2">
							<div
								className={"card card-body text-center picker-card" + (personalData.professionalSituation.includes(ProfessionOptions.unemployed) ? " active" : "")}
								onClick={() => {
									if (!personalData.professionalSituation.includes(ProfessionOptions.unemployed) && !personalData.professionalSituation.includes(ProfessionOptions.active) && !personalData.professionalSituation.includes(ProfessionOptions.retired)) {
										setPersonalData({ ...personalData, professionalSituation: [...personalData.professionalSituation.slice(), ProfessionOptions.unemployed] });
									} else {
										setPersonalData({ ...personalData, professionalSituation: personalData.professionalSituation.filter((p) => p !== ProfessionOptions.unemployed) });
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={pole} alt="pole" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">À FRANCE TRAVAIL</h2>
							</div>
						</div>
						<div className="form-group col col-lg-4 col-xl-2">
							<div
								className={"card card-body text-center picker-card" + (personalData.professionalSituation.includes(ProfessionOptions.other) ? " active" : "")}
								onClick={() => {
									if (!personalData.professionalSituation.includes(ProfessionOptions.other)) {
										setPersonalData({ ...personalData, professionalSituation: [...personalData.professionalSituation.slice(), ProfessionOptions.other] });
									} else {
										setPersonalData({ ...personalData, professionalSituation: personalData.professionalSituation.filter((p) => p !== ProfessionOptions.other) });
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={autre} alt="autre" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">AUTRE ACTIVITÉ</h2>
							</div>
						</div>
						<div className="form-group col col-lg-4 col-xl-2">
							<div
								className={"card card-body text-center picker-card" + (personalData.professionalSituation.includes(ProfessionOptions.none) ? " active" : "")}
								onClick={() => {
									if (!personalData.professionalSituation.includes(ProfessionOptions.none)) {
										setPersonalData({ ...personalData, professionalSituation: [ProfessionOptions.none] });
									} else {
										setPersonalData({ ...personalData, professionalSituation: personalData.professionalSituation.filter((p) => p !== ProfessionOptions.none) });
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={maison} alt="autre" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">SANS ACTIVITÉ</h2>
							</div>
						</div>
						<input type="text" id="professionFormFilled" className="d-none" />
						<div className={"invalid-feedback alert-danger alert"}>Veuillez choisir une option</div>
					</div>
				</div>
			</form>
		</section>
	);
};